import React, { useState, useEffect } from 'react';
import { useDesignFormStore } from '../../store/DesignMasterStore'; 
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../../components/ui/select";
import axiosApi from '../../server/service';
import SearchableDropdown from "../../components/customUI/SearchableDropdown"

interface VendorOption {
    _id: string;
    vendorName: string;
    contactNumber: string;
}

const AdditionalFabricTab: React.FC = () => {
  const { additionalFabric, updateAdditionalFabric } = useDesignFormStore();

        const [vendorOptions, setVendorOptions] = useState<{ label: string; value: string }[]>([]);
        const [isLoadingVendors, setIsLoadingVendors] = useState(true);

  console.log("Additional Fabric Details", additionalFabric)
  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    updateAdditionalFabric(name as keyof typeof additionalFabric, value);
  };

          useEffect(() => {
        const fetchVendors = async () => {
            setIsLoadingVendors(true);
            try {
                const response = await axiosApi.get('/api/vendors/getVendorsForDropdown', {
                  params: { vendorType: 'Fabric Supplier' }
                });
                console.log("response",response)
                if (response.data.success && Array.isArray(response.data.data)) {
            
                    // Format the API response for the Select component
                    const formattedVendors = response.data.data.map((vendor: VendorOption) => ({
                        label: vendor.vendorName,
                        value: vendor._id, 
                    }));
                    setVendorOptions(formattedVendors);
                }
            } catch (error) {
                console.error("Failed to fetch vendors:", error);
                // You could add a toast notification here for the user
            } finally {
                setIsLoadingVendors(false);
            }
        };

        fetchVendors();
    }, []);

  return (
    <div className="bg-white p-6 rounded-xl">
      <h2 className="text-xl font-bold text-gray-800 mb-2">Additional Fabric Specifications</h2>
        <p className="text-sm text-gray-500 mb-6">Optional: Add specifications for additional fabric if required for this design</p>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {/* Additional Fabric Type/Name */}
        <div className="md:col-span-1">
          <label className="block text-sm font-medium text-gray-700 mb-1">Additional Fabric Type/Name</label>
          <input
            type="text"
            name="fabricType"
            value={additionalFabric.fabricType}
            onChange={handleChange}
            placeholder="e.g., Lining, Interfacing"
            className="w-full px-3 py-2 border border-gray-300 rounded-lg"
          />
        </div>

        {/* Chart Name */}
        <div className="md:col-span-1">
          <label className="block text-sm font-medium text-gray-700 mb-1">Chart Name</label>
          <input
            type="text"
            name="chartName"
            value={additionalFabric.chartName}
            onChange={handleChange}
            placeholder="e.g., Chart B, Lining Chart"
            className="w-full px-3 py-2 border border-gray-300 rounded-lg"
          />
        </div>

        {/* Chart No */}
        <div className="md:col-span-1">
          <label className="block text-sm font-medium text-gray-700 mb-1">Chart No.</label>
          <input
            type="text"
            name="chartNo"
            value={additionalFabric.chartNo}
            onChange={handleChange}
            placeholder="e.g., CH002"
            className="w-full px-3 py-2 border border-gray-300 rounded-lg"
          />
        </div>

        {/* Vendor */}
        {/* <div className="md:col-span-1">
          <label className="block text-sm font-medium text-gray-700 mb-1">Vendor Details</label>
          <Select
            value={additionalFabric.vendorDetails}
            onValueChange={(value: string) => updateAdditionalFabric("vendorDetails", value)}
          >
            <SelectTrigger className="w-full border border-gray-300 rounded-lg px-3 text-sm min-h-[44px] h-auto">
              <SelectValue placeholder="Select vendor" className="whitespace-normal text-left" />
            </SelectTrigger>
            <SelectContent className="bg-white shadow-lg rounded-lg border max-w-[90vw]">
              {vendorOptions.map((vendor) => (
                <SelectItem
                  key={vendor.value}
                  value={vendor.value}
                  className="cursor-pointer hover:bg-gray-100 py-2 px-3 rounded-md whitespace-normal break-words text-sm"
                >
                  {vendor.label}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div> */}
        <div className="md:col-span-1">
          <label className="block text-sm font-medium text-gray-700 mb-1">Vendor Details</label>
            <SearchableDropdown
                options={vendorOptions}
                value={additionalFabric.vendorDetails || ''}
                onChange={(value) => updateAdditionalFabric("vendorDetails", value)}
                placeholder="Select or search vendor..."
                loading={isLoadingVendors}
            />
 
        </div>

        {/* Bill No */}
        <div className="md:col-span-2">
          <label className="block text-sm font-medium text-gray-700 mb-1">Bill No. with Date</label>
          <input
            type="text"
            name="billNoWithDate"
            value={additionalFabric.billNoWithDate}
            onChange={handleChange}
            placeholder="Bill number and date"
            className="w-full px-3 py-2 border border-gray-300 rounded-lg"
          />
        </div>

        {/* Additional Panna */}
        <div className="md:col-span-1">
          <label className="block text-sm font-medium text-gray-700 mb-1">Additional Panna</label>
          <input
            type="text"
            name="panna"
            value={additionalFabric.panna}
            onChange={handleChange}
            placeholder="Panna details"
            className="w-full px-3 py-2 border border-gray-300 rounded-lg"
          />
        </div>

        {/* Additional Panna Rate */}
        <div className="md:col-span-1">
          <label className="block text-sm font-medium text-gray-700 mb-1">Additional Panna Rate</label>
          <input
            type="number"
            name="pannaRate"
            value={additionalFabric.pannaRate}
            onChange={handleChange}
            placeholder="0.00"
            className="w-full px-3 py-2 border border-gray-300 rounded-lg"
          />
        </div>
        
        {/* Agent Name */}
        <div className="md:col-span-1">
          <label className="block text-sm font-medium text-gray-700 mb-1">Agent Name</label>
          <input
            type="text"
            name="agentName"
            value={additionalFabric.agentName}
            onChange={handleChange}
            placeholder="Agent name"
            className="w-full px-3 py-2 border border-gray-300 rounded-lg"
          />
        </div>
        
        {/* Discount Details */}
        <div className="md:col-span-1">
          <label className="block text-sm font-medium text-gray-700 mb-1">Discount Details</label>
          <input
            type="text"
            name="discountDetails"
            value={additionalFabric.discountDetails}
            onChange={handleChange}
            placeholder="Discount information"
            className="w-full px-3 py-2 border border-gray-300 rounded-lg"
          />
        </div>

        {/* Master Record Reference */}
        <div className="md:col-span-3">
          <label className="block text-sm font-medium text-gray-700 mb-1">Master Record Reference</label>
          <input
            type="text"
            name="masterRecordRef"
            value={additionalFabric.masterRecordRef}
            onChange={handleChange}
            placeholder="Reference to master fabric record"
            className="w-full px-3 py-2 border border-gray-300 rounded-lg"
          />
        </div>

        {/* Additional Fabric Notes */}
        <div className="md:col-span-3">
          <label className="block text-sm font-medium text-gray-700 mb-1">Additional Fabric Notes</label>
          <textarea
            name="fabricNotes"
            value={additionalFabric.fabricNotes}
            onChange={handleChange}
            placeholder="Special instructions, usage notes, etc."
            className="w-full px-3 py-2 border border-gray-300 rounded-lg h-24"
          />
        </div>
      </div>
    </div>
  );
};

export default AdditionalFabricTab;
